import moment from 'moment'
import _debounce from 'lodash/debounce'
import Fuse from 'fuse.js'
import {HostMaps} from './host/AutoHost'

const isHiya = (userAgent?: string) =>
  /inapp/i.test(userAgent || navigator.userAgent)

function getIn(
  obj: {[key: string]: any},
  keys: string,
  defaultValue: any = null
) {
  return keys.split('.').reduce(function (prev, key) {
    return prev && prev[key] ? prev[key] : defaultValue
  }, obj)
}

function delay(timeout: number): Promise<void> {
  return new Promise((resove) => {
    setTimeout(() => {
      resove()
    }, timeout)
  })
}

function joinCls(...args: string[]): string {
  return args.map((item) => item.trim()).join('-')
}

// function dateFormat(ms: number | string, fmt: string) {
//   const date = new Date(ms)
//   const o = {
//     'M+': date.getMonth() + 1, // 月份
//     'd+': date.getDate(), // 日
//     'h+': date.getHours(), // 小时
//     'm+': date.getMinutes(), // 分
//     's+': date.getSeconds(), // 秒
//     'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
//     S: date.getMilliseconds(), // 毫秒
//   }
//   if (/(y+)/.test(fmt))
//     fmt = fmt.replace(
//       RegExp.$1,
//       `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
//     )
//   for (const k in o)
//     if (new RegExp(`(${k})`).test(fmt))
//       fmt = fmt.replace(
//         RegExp.$1,
//         RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
//       )
//   return fmt
// }

export const getHeader = () => {
  const url = window.location.href
  try {
    const header = JSON.parse(decodeURIComponent(url.split('header=')[1]))
    return header
  } catch (e) {
    return {}
  }
}
// function queryString(url: string): {[propName: string]: string} {
//   const headerStr = url.split('header=')[1]
//   const queryStr = url.split('header=')[0].replace(/(.*?\?)/, '')
//   const ary = queryStr.split('&')
//   return ary.reduce(
//     (prev, next) => {
//       const [key, value] = next.split('=')
//       prev[key] = value
//       return prev
//     },
//     {header: headerStr}
//   )
// }

function transSlot(tpl: string, data: {[propsName: string]: any}): string {
  return data && tpl ? tpl.replace(/%(\w+)%/g, (a, b) => data[b]) : tpl
}

function formatDuration(duration: number) {
  // 计算出小时数
  const leftHours = duration % (24 * 3600) // 计算天数后剩余的毫秒数
  const day = Math.floor(duration / (24 * 3600))
  const hours = Math.floor(leftHours / 3600) + day * 24
  const leftMinutes = leftHours % 3600 // 计算小时数后剩余的毫秒数
  const minutes = Math.floor(leftMinutes / 60)
  const seconds = leftMinutes % 60 // 计算分钟数后剩余的毫秒数
  const resAry = [
    hours > 0 ? `${hours}h` : '',
    minutes > 0 ? `${minutes}min` : '',
    seconds > 0 ? `${seconds}s` : '',
  ]
  return resAry.join('')
}

function formatBigNum(num: number, toFixed = 2) {
  const million = 1000000
  const kilo = 1000

  if (num >= million) {
    return `${(num / million).toFixed(toFixed)}m`
  }
  if (num >= kilo * 10) {
    return `${(num / kilo).toFixed(toFixed)}k`
  }
  return `${num}`
}
export const formatTimeStr = (time: any, format = 'YYYY-MM-DD HH:mm:ss') =>
  moment(time).format(format)
// eslint-disable-next-line @typescript-eslint/ban-types
const debounce = (func: Function, wait: number, immediate?: boolean) => {
  let timeout
  return function (...args) {
    let context = this; // eslint-disable-line
    if (timeout) clearTimeout(timeout)
    if (immediate) {
      const callNow = !timeout
      timeout = setTimeout(function () {
        timeout = null
      }, wait)
      if (callNow) func.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait)
    }
  }
}

const getPic = (id) => {
  return `${HostMaps.auto.img01}/img/png/id/${id}`
}

const formatTime2Arr = (t = 0) => {
  const rule = [24, 60, 60]
  let result = []
  let theTime = parseInt(String(t), 10)
  while (rule.length > 0) {
    const r = rule.pop()
    const n = theTime % r
    result.push(n > 9 ? `${n}` : `0${n}`)
    theTime = Math.floor(theTime / r)
    if (rule.length === 0)
      result.push(theTime > 9 ? `${theTime}` : `0${theTime}`)
  }
  // [天, 时, 分, 秒]
  result = result.reverse()
  return result
}
// Fisher–Yates 随机乱序数组算法
const getFreeList = (arr) => {
  // 临时数组，用于存值
  const arrAdd = [...arr]
  for (let i = 1; i < arrAdd.length; i += 1) {
    const random = Math.floor(Math.random() * (i + 1))
    // 交换两个数组
    ;[arrAdd[i], arrAdd[random]] = [arrAdd[random], arrAdd[i]]
  }
  return arrAdd
}

const preloaImg = (src) => {
  return new Promise((res) => {
    const img = new Image()
    img.src = src
    img.onload = () => {
      res(null)
    }
  })
}

const debounceOpenScheme = _debounce((url) => {
  window.HiyaJSBridge.callHandler('openScheme', {
    url,
  })
}, 500)
const imgPlaceHolder = `${HostMaps.prod.img01}/img/png/id/166568502347`

// 数组补空
const getCompleteArr = (arr, num) => {
  const len = arr?.length || 0
  if (len < num) {
    const arr1 = new Array(num - len).fill({})
    return [...arr, ...arr1]
  }
  return arr?.slice(0, num)
}
const fuseSearch = ({
  data,
  options,
  searchVal,
}: {
  data: any[]
  options: {
    keys: string[]
  }
  searchVal: string
}) => {
  const fuseOptions = {
    // isCaseSensitive: false,
    // includeScore: false,
    shouldSort: false,
    // includeMatches: false,
    // findAllMatches: false,
    minMatchCharLength: 1,
    // location: 0,
    threshold: 0.1,
    // distance: 100,
    // useExtendedSearch: false,
    // ignoreLocation: false,
    // ignoreFieldNorm: false,
    // fieldNormWeight: 1,
    ...options,
  }
  const fuse = new Fuse(data, fuseOptions)
  const res = fuse.search(searchVal)
  return res?.map((v) => ({...(v as any).item}))
}
const getGameId = (path = '') => {
  const arr = (path || window.location.pathname).split('/')
  return Number(arr[arr.length - 1])
}
export {
  // dateFormat,
  debounce,
  debounceOpenScheme,
  delay,
  formatBigNum,
  formatDuration,
  formatTime2Arr,
  fuseSearch,
  getCompleteArr,
  getFreeList,
  getGameId,
  getIn,
  getPic,
  imgPlaceHolder,
  isHiya,
  joinCls,
  preloaImg,
  // queryString,
  transSlot,
}
